<!-- <div class="home-page" *ngIf="cmsContent">
  <div class="home-page__header">
    <div *ngIf="!isMobile" class="home-page__header--text-block">
      <h1>{{ cmsContent.title }}</h1>
      <div
        matRipple
        data-cy="zoekPassendeFunctie"
        class="home-page__primary-action-button"
        routerLink="profielopbouw"
        *ngIf="cmsContent?.cta?.active"
      >
        <div class="home-page__text-block">
          <h3>{{ cmsContent.cta.title }}</h3>
          <p>{{ cmsContent.cta.subtitle }}</p>
        </div>
        <mat-icon class="material-icons home-page__icon">
          arrow_forward_ios
        </mat-icon>
      </div>
    </div>
    <div *ngIf="!isMobile" class="home-page__header--image-block">
      <img [src]="cmsContent.cta.backgroundImage.url" alt="" />
    </div>

    <div *ngIf="isMobile" class="home-page__header--text-block">
      <h1>{{ "homePage.headerTitle" | content }}</h1>

      <div
        class="home-page__header--cta-button-mobile"
        *ngIf="cmsContent.cta.active"
      >
        <div
          matRipple
          data-cy="zoekPassendeFunctie"
          class="home-page__primary-action-button"
          routerLink="profielopbouw"
          *ngIf="cmsContent?.cta?.active"
        >
          <div class="home-page__text-block">
            <h3>{{ cmsContent.cta.title }}</h3>
            <p>{{ cmsContent.cta.subtitle }}</p>
          </div>
          <mat-icon class="material-icons home-page__icon">
            arrow_forward_ios
          </mat-icon>
        </div>

        <img
          [src]="cmsContent.cta.backgroundImage.url"
          [alt]="cmsContent.cta.backgroundImage.alt"
        />
      </div>
    </div>
    <div class="home-page__header--background-image">
      <img
        src="/assets/images/helpende-zorg-en-welzijn.webp"
        alt="Zorginspirator"
      />
      <div class="home-page__header--background-image-overlay"></div>
    </div>
  </div>

  <div class="home-page__actions" *ngIf="cmsContent">
    <ng-container *ngFor="let cta of activeCtas()">
      <ng-template #linkContent>
        <div class="home-page__action--text-block">
          <h2>
            <mat-icon class="material-icons action-button--icon">{{
              cta.icon
            }}</mat-icon>
            <span>{{ cta.title }}</span>
          </h2>
          <p>{{ cta.subtitle }}</p>
        </div>
        <mat-icon class="material-icons action-button--arrow"
          >arrow_forward_ios</mat-icon
        >
      </ng-template>

      <a
        *ngIf="cta.external; else internalLink"
        [href]="cta.link"
        matRipple
        class="home-page__action-{{ cta.class }}"
        [ngStyle]="{ backgroundColor: cta.color }"
      >
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
      </a>

      <ng-template #internalLink>
        <a
          [routerLink]="cta.link"
          matRipple
          class="home-page__action-{{ cta.class }}"
          [ngStyle]="{ backgroundColor: cta.color }"
        >
          <ng-container *ngTemplateOutlet="linkContent"></ng-container>
        </a>
      </ng-template>
    </ng-container>
  </div>

  <app-lane *ngFor="let lane of cmsContent?.lanes" [items]="lane.items">
  </app-lane>
</div> -->
<main>
  <div class="homepage">
    <div class="homepage__content-wrapper">
      <div class="homepage__text-container">
        <h1>
          <span class="homepage__title_eyebrow">Werken en leren in de zorg</span>
          <span class="homepage__title">Er is meer mogelijk dan je denkt</span>
        </h1>
      </div>
    </div>
    <div class="homepage__image-wrapper">
      <img class="homepage__image" src="/assets/images/homepage-header.webp" alt="Zorginspirator">
    </div>
  </div>
  <div class="homepage__actions">
    <a routerLink="/functies" matRipple class="homepage__action-functies">
      <div class="homepage__action--text-block">
        <div class="homepage__action--text-block-title">
          <svg width="84" height="84" viewBox="0 0 84 84" fill="currentColor" class="icon"
            xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_58_1318)">
              <path
                d="M73.8149 83.9862C72.5024 83.9862 71.2556 83.4743 70.3237 82.5424L51.1479 63.354C49.5336 61.8578 48.6804 60.204 48.6279 58.4584C48.5885 57.2115 48.9823 56.1877 49.3761 55.4921L45.2286 51.3446C44.7298 50.8459 44.7298 50.0453 45.2286 49.5465C45.7273 49.0476 46.5279 49.0477 47.0267 49.5465L51.9355 54.4552C52.4211 54.9408 52.4342 55.7415 51.9486 56.2402C51.5942 56.634 49.9142 58.7602 52.9198 61.5427L72.1348 80.771C73.0667 81.7029 74.5761 81.7029 75.508 80.771L80.758 75.521C81.2043 75.0748 81.4536 74.471 81.4536 73.841C81.4536 73.1979 81.2043 72.6073 80.758 72.1479L61.5696 52.9461C58.7478 49.9143 56.6214 51.5811 56.2278 51.9486C55.729 52.408 54.9415 52.408 54.4559 51.9224L49.5603 47.0267C49.0615 46.528 49.0615 45.7274 49.5603 45.2286C50.059 44.7298 50.8596 44.7298 51.3584 45.2286L55.4928 49.3629C56.1884 48.9692 57.1859 48.5886 58.459 48.6148C60.2047 48.6673 61.8584 49.5204 63.394 51.1741L82.5565 70.3107C83.4884 71.2425 84.0003 72.4764 84.0003 73.802C84.0003 75.1145 83.4884 76.3613 82.5565 77.2932L77.3065 82.5432C76.3747 83.475 75.1278 83.987 73.8153 83.987L73.8149 83.9862Z" />
              <path
                d="M28.8883 57.7892C21.4725 57.7892 14.0833 54.9279 8.4658 49.3108C3.0058 43.8508 0 36.5925 0 28.875C0 21.1575 3.00566 13.8992 8.4658 8.43916C19.7274 -2.80915 38.0492 -2.80915 49.3241 8.43916C59.7583 18.9 60.6641 35.4375 51.4373 46.935C50.7548 47.7881 50.046 48.5756 49.3241 49.2975C48.5104 50.0981 47.6966 50.82 46.9223 51.4368C41.6198 55.6893 35.2407 57.7893 28.8889 57.7893L28.8883 57.7892ZM28.8883 2.55916C22.1421 2.55916 15.3958 5.1185 10.2641 10.2508C5.28976 15.2251 2.5466 21.84 2.5466 28.875C2.5466 35.91 5.28976 42.525 10.2641 47.4992C19.7666 57.015 34.8474 57.855 45.3341 49.4417C46.0559 48.8773 46.7909 48.221 47.5259 47.486C48.1691 46.8429 48.8253 46.1078 49.4553 45.3335C57.8686 34.8601 57.0286 19.766 47.5259 10.2369C42.3941 5.11815 35.6343 2.5586 28.8884 2.5586L28.8883 2.55916Z" />
              <path
                d="M35.8442 47.814H21.9317C20.291 47.814 18.6767 47.3808 17.2592 46.5671C16.9048 46.3702 16.6161 46.1209 16.3798 45.8584C12.5342 41.4615 16.9311 34.9517 17.1148 34.6759C18.2436 33.0221 19.7005 31.7359 21.4461 30.8565C22.4567 30.3578 23.5461 30.069 24.7143 30.0165C24.9243 30.0034 25.1343 30.0297 25.3574 30.0822C27.9299 30.7778 30.4367 30.7909 32.8257 30.1478C33.0882 30.0822 33.3507 30.0559 33.6 30.0822C34.7157 30.2003 35.7657 30.5415 36.7369 31.0665C38.2987 31.9327 39.6112 33.1402 40.6481 34.6627C40.8319 34.9384 45.2288 41.4352 41.3831 45.8452C41.1469 46.1077 40.8581 46.3571 40.5038 46.554C39.0994 47.3808 37.485 47.814 35.8444 47.814L35.8442 47.814ZM24.7667 32.5624C23.9792 32.6017 23.2573 32.7986 22.5879 33.1267C21.2361 33.7961 20.0942 34.8067 19.2148 36.1061C19.1754 36.1586 15.7498 41.2642 18.296 44.1778C18.3223 44.204 18.3879 44.2696 18.5323 44.3615C19.5691 44.9521 20.7373 45.2672 21.9316 45.2672H35.8441C37.0385 45.2672 38.2066 44.9522 39.2434 44.3615C39.3878 44.2828 39.4534 44.2171 39.4797 44.1909C41.9997 41.3034 38.6004 36.1717 38.5609 36.1192C37.7472 34.9249 36.7234 33.9799 35.5159 33.3104C34.8728 32.9561 34.1772 32.7329 33.4291 32.6411C30.6466 33.3761 27.7329 33.3498 24.7666 32.5623L24.7667 32.5624Z" />
              <path
                d="M28.8883 26.5384C24.4258 26.5384 20.79 22.9027 20.79 18.4401C20.79 13.9775 24.4257 10.3418 28.8883 10.3418C33.351 10.3418 36.9866 13.9775 36.9866 18.4401C36.9866 22.9027 33.351 26.5384 28.8883 26.5384ZM28.8883 12.8884C25.8302 12.8884 23.3365 15.3821 23.3365 18.4402C23.3365 21.4983 25.8302 23.9921 28.8883 23.9921C31.9464 23.9921 34.4402 21.4983 34.4402 18.4402C34.4402 15.3821 31.9464 12.8884 28.8883 12.8884Z" />
            </g>
            <defs>
              <clipPath id="clip0_58_1318">
                <rect width="84" height="84" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <h2>
            <span>Functies</span>
          </h2>
        </div>
        <p>400+ zorgfuncties, welke functie past bij jou?</p>
      </div>

    </a>
    <a routerLink="/opleidingen" matRipple class="homepage__action-opleidingen">
      <div class="homepage__action--text-block">
        <div class="homepage__action--text-block-title">
          <svg width="89" height="55" viewBox="0 0 89 55" fill="currentColor" class="icon"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M85.5735 38.2354V21.3761L86.1671 21.1588C87.5646 20.6487 88.4741 19.3737 88.4741 17.9004C88.4741 16.4271 87.5649 15.1518 86.1671 14.642L46.8741 0.474558C45.1224 -0.158186 43.3517 -0.158186 41.5999 0.474558L2.307 14.6515C0.909496 15.1616 0 16.4366 0 17.9098C0 19.3831 0.909177 20.6585 2.307 21.1682L14.1475 25.4372V39.2458C14.1475 41.607 15.1814 43.7134 17.0574 45.1867C25.4424 51.732 34.8421 55 44.2322 55C53.6223 55 63.0315 51.732 71.407 45.1867C73.2831 43.7225 74.3169 41.607 74.3169 39.2458L74.3166 25.4372L82.692 22.4149V38.2353C80.701 38.8493 79.2462 40.6531 79.2462 42.816V48.2374C79.2462 50.1451 80.8257 51.7036 82.759 51.7036H85.487C87.4203 51.7036 88.9998 50.1451 88.9998 48.2374V42.816C89.0191 40.6531 87.5643 38.8397 85.5733 38.2353L85.5735 38.2354ZM2.87172 17.9098C2.87172 17.6264 3.02502 17.4093 3.29298 17.3149L42.5859 3.12853C43.7057 2.72238 44.7586 2.72238 45.8787 3.12853L85.1716 17.3055C85.4396 17.3998 85.5929 17.6172 85.5929 17.9004C85.5929 18.1839 85.4396 18.4009 85.1716 18.4953L83.9178 18.9488L44.3186 16.4837C43.524 16.4363 42.8445 17.0315 42.7968 17.806C42.7488 18.59 43.352 19.2606 44.1369 19.3076L77.2081 21.3666L45.8886 32.6817C44.7688 33.0879 43.7159 33.0879 42.5958 32.6817L3.2933 18.5048C3.02533 18.4009 2.87204 18.1835 2.87204 17.9096L2.87172 17.9098ZM71.4548 39.2461C71.4548 40.7667 70.8423 42.023 69.6361 42.9579C53.9763 55.1892 34.507 55.1892 18.8472 42.9579C17.6411 42.0134 17.0285 40.7667 17.0285 39.2461V26.467L41.6093 35.3358C42.4805 35.6476 43.361 35.8081 44.2416 35.8081C45.1221 35.8081 46.0027 35.6476 46.8739 35.3358L71.4547 26.467L71.4548 39.2461ZM86.1478 48.2282C86.1478 48.5778 85.8605 48.861 85.5066 48.861H82.7786C82.4243 48.861 82.1374 48.5775 82.1374 48.2282V42.8069C82.1374 41.7111 83.0372 40.8235 84.1474 40.8235C85.2579 40.8235 86.1574 41.7114 86.1574 42.8069V48.2282H86.1478Z" />
          </svg>
          <h2>
            <span>Opleidingen</span>
          </h2>
        </div>
        <p>Voor omscholing, specialisaties en meer</p>
      </div>

    </a>
    <!-- <a routerLink="/" fragment="inspiratie" skipLocationChange="true" mat matRipple class="homepage__action-testen">
      <div class="homepage__action--text-block">
        <div class="homepage__action--text-block-title">
          <svg width="61" height="73" viewBox="0 0 61 73" fill="currentColor" class="icon"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M59.3358 38.8043C58.759 37.9225 58.2106 37.1042 57.7284 36.3869C56.4665 34.5102 55.0369 32.38 55.018 31.7638C55.0748 30.8281 55.3 29.912 55.6834 29.0559C56.102 28.0097 56.4063 26.9196 56.5869 25.8073C57.4552 19.8731 55.5982 13.8627 51.5305 9.44249C48.6457 6.31122 45.0798 3.87766 41.1041 2.33865C37.1135 0.733585 32.8403 -0.0598498 28.5393 0.00351713C18.4652 0.190247 9.4974 4.50998 4.54993 11.5558C1.14838 16.2672 -0.433372 22.0471 0.10222 27.8263C0.530288 32.7305 2.31154 37.8747 5.5447 43.5561C11.6499 54.2934 11.7831 57.9114 11.3584 71.5245C11.3456 71.9101 11.4917 72.2863 11.7642 72.564C12.0333 72.8417 12.4046 73.0002 12.7941 73.0002H38.9583C39.3512 73.0002 39.7286 72.839 40.0011 72.5512C40.2703 72.2667 40.413 71.8845 40.3913 71.4895C40.3467 70.696 40.3277 65.7035 40.344 65.2107H40.3474C40.3507 64.4274 40.5976 63.6657 41.0513 63.0273C41.666 63.1439 42.3132 63.2551 42.9976 63.3589C43.6414 63.4661 44.2656 63.5551 44.8708 63.6272H44.9466C48.2528 63.9117 51.6543 64.0317 53.6918 62.1705L53.6952 62.1738C54.8746 61.0049 55.4893 59.3897 55.3845 57.7375C55.3845 56.5018 55.2608 54.6689 55.1404 52.8967C55.0105 50.9882 54.8773 49.0131 54.9091 47.9385C54.9247 47.4363 55.5745 47.1674 57.0332 46.7568C57.4836 46.6402 57.9272 46.498 58.3614 46.3335C59.5022 45.9796 60.4185 45.1295 60.85 44.0206C61.2747 42.6872 60.8087 41.0787 59.3345 38.8036H59.3352L59.3358 38.8043ZM58.1118 43.1557C58.0767 43.2629 57.8427 43.459 57.2875 43.6835C57.0116 43.7941 56.6376 43.8986 56.2474 44.0058C54.7001 44.4419 52.1074 45.172 52.0344 47.861C51.9992 49.0778 52.1324 51.0307 52.2785 53.0969C52.3955 54.8219 52.5226 56.6043 52.5226 57.7422H52.5192C52.6078 58.5889 52.3319 59.4329 51.7618 60.0679C50.5892 61.1424 47.7868 61.0036 45.2346 60.7852C44.6037 60.7029 44.0045 60.6146 43.4345 60.5263H43.4378C40.0302 59.8819 36.6922 58.9145 33.4719 57.635C34.1028 56.94 34.4545 56.0327 34.4545 55.0916V52.7214C34.4545 52.3425 34.3023 51.9785 34.0332 51.7102C33.764 51.4419 33.3989 51.2902 33.0188 51.2902H25.4712C24.6786 51.2902 24.0355 51.932 24.0355 52.7214V55.0916C24.0355 57.1928 25.7444 58.8929 27.8489 58.8929H28.9552C31.9537 60.198 35.0286 61.3137 38.1671 62.2332C37.7708 63.1082 37.5429 64.0472 37.4888 65.0045V65.02C37.4665 65.3233 37.476 68.2402 37.5017 70.1358H14.2724C14.6464 57.335 14.2785 53.107 8.04007 42.1452C1.57645 30.7843 1.20586 21.3177 6.90532 13.2C11.3273 6.89905 19.4356 3.03839 28.5941 2.86716C36.4873 2.72155 44.6531 6.04899 49.3855 11.3482C52.8851 15.1496 54.4858 20.3193 53.7412 25.4251C53.5857 26.3352 53.3321 27.223 52.9838 28.0798C52.4672 29.2676 52.1818 30.5416 52.1466 31.8366C52.1845 33.2806 53.3037 34.949 55.3419 37.9859C55.8207 38.6998 56.3657 39.5087 56.927 40.3682C58.2552 42.4061 58.1477 43.0512 58.1125 43.155L58.1118 43.1557ZM31.5831 55.0909C31.577 55.6059 31.1584 56.0232 30.6418 56.0293H27.8428C27.3261 56.0232 26.9109 55.6059 26.9041 55.0909V54.1525H31.5831V55.0909ZM29.244 22.8857C25.8776 22.8857 22.6539 24.2353 20.2985 26.6331C17.9431 29.0282 16.6562 32.2674 16.7225 35.6231C16.7921 38.9755 18.2123 42.1607 20.663 44.4581C21.5983 45.3048 22.2001 46.4548 22.3651 47.7033C22.4605 48.4145 23.0691 48.9484 23.7886 48.9484H34.6959C35.4154 48.9484 36.0241 48.4145 36.1194 47.7033C36.2844 46.4548 36.8897 45.3048 37.8216 44.4581C40.275 42.1607 41.6917 38.9755 41.7621 35.6231C41.8284 32.2674 40.5414 29.0282 38.1861 26.6331C35.8307 24.238 32.607 22.8857 29.2433 22.8857H29.244ZM35.8597 42.3764C34.7629 43.3782 33.9581 44.661 33.5361 46.0861H24.9518C24.5305 44.661 23.7285 43.3782 22.6316 42.3764C20.6853 40.5624 19.5823 38.025 19.5945 35.371C19.5945 30.0563 23.9151 25.7487 29.244 25.7487C34.5728 25.7487 38.8934 30.0556 38.8934 35.371C38.9063 38.0257 37.806 40.563 35.8597 42.3764ZM27.8083 18.9522V15.1731C27.8272 14.3959 28.4642 13.7764 29.244 13.7764C30.0237 13.7764 30.6607 14.3959 30.6797 15.1731V18.9522C30.6891 19.3378 30.5403 19.7106 30.2705 19.9857C30.0014 20.2634 29.6301 20.4184 29.2433 20.4184C28.8565 20.4184 28.4859 20.2634 28.2161 19.9857C27.9435 19.7106 27.7975 19.3378 27.8069 18.9522H27.8083ZM36.8714 20.6079L38.767 17.3344C39.1693 16.6643 40.0383 16.4432 40.7132 16.8321C41.3915 17.2238 41.6322 18.0833 41.2522 18.7662L39.3566 22.0397L39.36 22.0363C38.9637 22.7219 38.086 22.9558 37.3975 22.5608C36.7091 22.1657 36.4751 21.2907 36.8714 20.6079ZM49.1359 25.1892C49.5322 25.8747 49.2976 26.7504 48.6098 27.1454L45.3259 29.035H45.3293C44.6416 29.4138 43.782 29.1739 43.3891 28.4977C42.9989 27.8216 43.2214 26.9587 43.8902 26.5576L47.1741 24.6681C47.5041 24.4786 47.897 24.4247 48.2642 24.5225C48.6315 24.6202 48.9459 24.8609 49.1359 25.1892ZM17.2344 18.7655C16.8543 18.0833 17.0951 17.2231 17.7734 16.8315C18.4517 16.4425 19.3173 16.6643 19.723 17.3337L21.6185 20.6072H21.6152C22.0114 21.2894 21.7768 22.1651 21.0924 22.5601C20.4047 22.9551 19.5262 22.7212 19.1299 22.0356L17.2344 18.7655ZM15.1231 28.5105C14.9331 28.8395 14.6193 29.0795 14.2515 29.1772C13.8836 29.2783 13.494 29.2244 13.164 29.035L9.88016 27.1454C9.19241 26.7504 8.95775 25.8754 9.35403 25.1892C9.75031 24.507 10.6281 24.2697 11.3165 24.6647L14.5977 26.5576C15.2854 26.9526 15.5201 27.8276 15.1238 28.5105H15.1231Z" />
          </svg>
          <h2>
            <span>Inspiratie</span>
          </h2>
        </div>
        <p>Doe ideeën op voor jouw volgende stap.</p>
      </div>
    </a> -->
  </div>
  <div id="inspiratie" class="homepage__linkcards_wrapper">
    <section>
      <div>
        <h2>Inspiratie - doe ideeën op</h2>
        <p>Ben je toe aan een verandering in je werk, maar weet je niet precies wat je zoekt? Op Zorginspirator doe je ideeën op voor jouw volgende stap in de zorg. Vind inspiratie in de functies van de toekomst, verhalen van zorgcollega’s en tips van loopbaanexperts. Of doe een van de zelfkennistests.</p>
      </div>
      <div class="homepage__linkcards">
        <a routerLink="/functietoekomstopbouw" class="homepage__linkcards_big">
          <div class="text-container">
            <div>
              <h4 class="card-title">Jouw baan in 2030</h4>
              <p class="card-description">Met de tijd veranderen beroepen en functies. Ook in de zorgsector. Taken
                vervallen, andere komen erbij. En wie weet welke kansen dit biedt voor jou.</p>
            </div>
            <img src="/assets/images/robot.png" alt="Pepper robot, een robot met een tablet op zijn borst"
              class="image-robot">
            <p class="card-highlight">
              Bekijk jouw functie in de toekomst
            </p>
          </div>
        </a>
        <a routerLink="/test-overzicht" class="homepage__linkcards_big blue">
          <div class="text-container">
            <div>
              <h4 class="card-title">Wat werkt voor jou?</h4>
              <p class="card-description">Waar krijg je nou écht energie van? Stel vast wat jou kenmerkt en wat je
                belangrijk vindt. Dat helpt bij weten wat je zoekt bij een baan in de zorg.</p>
            </div>
            <img src="/assets/images/tests.png" alt="een illustratie van een ingevulde test" class="image-test">
            <p class="card-highlight">
              Doe een test
            </p>
          </div>
        </a>
        <a routerLink="/profielopbouw" class="homepage__linkcards_small blue">
          <div class="text-container">
            <h4 class="card-title">Functiematch</h4>
            <p class="card-highlight">
              Match met jouw zoekprofiel
            </p>
          </div>
        </a>
        <a href="https://welkom.zorginspirator.nl/loopbaan" class="homepage__linkcards_small blue">
          <div class="text-container">
            <h4 class="card-title">Loopbaan inspiratie</h4>
            <p class="card-highlight">
              Lees tips en verhalen
            </p>
          </div>
        </a>
      </div>
    </section>
    <section>
      <div>
        <h2>Leren en werken tegelijk</h2>
        <p>Of je nou nieuw bent in de zorg, wil bijleren of interesse hebt in omscholing: met flexibele leerroutes zoals
          mbo-certificaten en EPA's kun je alle kanten op. Je combineert leren met werken. En nieuwe vaardigheden breng je
          direct in de praktijk.</p>
      </div>
      <div class="homepage__linkcards">
        <a style="order: 0" href="https://welkom.zorginspirator.nl/zorgprofessional/mbo-certificaten" class="homepage__linkcards_small">
          <div class="text-container">
            <h4 class="card-title">Mbo-certificaten Zorgsector</h4>
            <p class="card-highlight">
              Zoek een leerroute
            </p>
          </div>
        </a>
        <a style="order: 0" href="https://welkom.zorginspirator.nl/zorgprofessional/epas-in-de-zorg" class="homepage__linkcards_small">
          <div class="text-container">
            <h4 class="card-title">EPA's Zorgsector</h4>
            <p class="card-highlight">
              Ontdek EPA-opleidingen
            </p>
          </div>
        </a>
      </div>
    </section>
  </div>
  <img class="homepage__about_image-mobile" src="/assets/images/homepage-second-image.webp" alt="Zorginspirator">
  <div class="homepage__about_wrapper">
    <div class="homepage__about">
      <div class="homepage__about_image_wrapper">
        <img class="homepage__about_image" src="/assets/images/homepage-second-image.webp" alt="Zorginspirator">
      </div>
      <div style="padding-bottom: 2rem;">
        <h2 style="margin-bottom: 2rem;">Wat anderen zeggen</h2>
        <div class="homepage__testimonials">
          <app-slider></app-slider>
        </div>
      </div>
    </div>
    
  </div>
</main>